import { Panel } from './Panel';

const METERS = [
  { key: 'intensity', label: 'Intensity', color: 'var(--teal)' },
  { key: 'activity', label: 'Activity', color: 'var(--spore)' },
  { key: 'agitation', label: 'Agitation', color: 'var(--coral)' },
  { key: 'calm', label: 'Calm', color: 'var(--amber)' },
];

const Meter = ({ label, value, color, id }) => (
  <div data-testid={`meter-${id}`} data-value={value.toFixed(3)}>
    <div className="mb-1 flex items-baseline justify-between">
      <span className="label-eyebrow">{label}</span>
      <span data-testid={`meter-${id}-value`} className="text-xl tabular-nums" style={{ color }}>{value.toFixed(2)}</span>
    </div>
    <div className="meter-track">
      <div className="meter-fill" style={{ background: color, transform: `scaleX(${value})`, boxShadow: `0 0 16px ${color}` }} />
    </div>
  </div>
);

export const Meters = ({ state, stillThresholds }) => {
  const s = state.stillnessSeconds;
  return (
    <Panel testId="meters-panel" code="03 / AFFECT" title="Signal Meters" delay={140}>
      <div className="space-y-4">
        {METERS.map((m) => (
          <Meter key={m.key} id={m.key} label={m.label} value={state[m.key]} color={m.color} />
        ))}
        <div data-testid="meter-stillness" data-value={s.toFixed(2)} className="flex items-end justify-between border-t border-[var(--hair)] pt-4">
          <div>
            <div className="label-eyebrow">Stillness</div>
            <div className="mt-1 flex gap-2 text-xs">
              {stillThresholds.map((th) => (
                <span key={th} className={`border px-2 py-0.5 ${s >= th ? 'border-[var(--teal)] text-[var(--teal)]' : 'border-[var(--dim)] text-[var(--dim)]'}`}>{th}s</span>
              ))}
            </div>
          </div>
          <span data-testid="meter-stillness-value" className="font-display text-4xl font-bold tabular-nums glow-teal">{s.toFixed(1)}<span className="text-lg">s</span></span>
        </div>
        <div data-testid="stroking-indicator" data-active={state.stroking ? 'true' : 'false'} className={`text-xs tracking-[0.2em] ${state.stroking ? 'text-[var(--amber)]' : 'text-[var(--dim)]'}`}>
          {state.stroking ? '● STROKING IN PROGRESS' : '○ NOT STROKING'}
        </div>
      </div>
    </Panel>
  );
};
